module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-02-en.c6148f0a67036910143c53d1fae18d11.png";